import { useRef, type ReactNode } from 'react';
import { Pressable, View, type StyleProp, type ViewStyle } from 'react-native';

export type PhotoInputProps = {
  label: string;
  /** Receives `upload://<filename>`: the API has no upload endpoint yet, so only the reference is stored. */
  onPicked: (reference: string) => void;
  /** `user` opens the front camera (selfie), `environment` the back one. */
  camera?: 'user' | 'environment';
  style?: StyleProp<ViewStyle>;
  children: ReactNode;
};

/** Web-only: a hidden `<input type=file capture>` opens the camera on phones and a picker on desktop. */
export const PhotoInput = ({ label, onPicked, camera = 'environment', style, children }: PhotoInputProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  return (
    <View style={style}>
      <Pressable accessibilityRole="button" accessibilityLabel={label} onPress={() => inputRef.current?.click()} style={{ flex: 1 }}>
        {children}
      </Pressable>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture={camera}
        tabIndex={-1}
        aria-hidden
        style={{ display: 'none' }}
        onChange={(event) => {
          const file = event.currentTarget.files?.[0];
          if (file) onPicked(`upload://${file.name}`);
          event.currentTarget.value = '';
        }}
      />
    </View>
  );
};
